import React from 'react'


export default () => (
    <div>
        <div style={{maxWidth: 900, padding: '40px 20px', margin: 'auto', fontSize: '1.1rem'}}>
            <p>
                Welcome on behalf of our team. The CPM is a multidisciplinary health centre staffed by a group of psychologists, marriage and family counselors providing counselling and therapies in the Ottawa and Gatineau regions. We offer individual, couple and family counselling. Our most important objective is that you feel listened to and understood in your current difficulties. We operate in a confidential and welcoming environment.
            </p>
            <p>
                Our therapists employ integrative and client-centred approaches. Cognitive and Behavioral Therapy (CBT), Solution-Focused Therapies, Psychodynamic Therapy, Neurolinguistic Programming (NLP) and many more.
            </p>
            <p>
                We use a variety of family therapy approaches aimed at improving family communication and functioning, resolving interpersonal conflicts, and developing coping and problem-solving skills in families.
            </p>
            <p>
                Our therapists are at your service and are ready to help you find ways to overcome the challenges you face.
            </p>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/componentsEn/Contents/Home/HomePage.js